/**
 * Authentication Service
 * Handles all authentication-related operations
 */
import apiService from './api';
import config from '../config';

class AuthService {
  /**
   * Initiate Google OAuth flow
   * Uses full page navigation to OAuth provider
   */
  initiateGoogleLogin() {
    // For OAuth flows, we need full page navigation, not fetch
    window.location.href = config.auth.googleLoginUrl;
  }

  /**
   * Handle OAuth callback (cookie-based authentication)
   */
  async handleOAuthCallback(searchParams) {
    // With cookie-based auth, no token processing needed
    // The server already set the httpOnly cookie during redirect
    
    // Just validate the cookie and get user info
    const user = await this.getCurrentUser();
    
    return user;
  }

  /**
   * Get current authenticated user
   */
  async getCurrentUser() {
    try {
      const response = await apiService.get('/auth/me');
      return await response.json();
    } catch (error) {
      // Don't log 401 errors as they're expected when not authenticated
      if (error.status === 401) {
        const authError = new Error('Not authenticated');
        authError.status = 401;
        throw authError;
      }
      throw error;
    }
  }

  /**
   * Set username for new users
   */
  async setUsername(username) {
    const response = await apiService.post('/auth/set-username', { username });
    return await response.json();
  }

  /**
   * Check if username is available
   */
  async checkUsernameAvailability(username) {
    const response = await apiService.post('/auth/check-username', { username });
    return await response.json();
  }

  /**
   * Logout user
   */
  async logout() {
    try {
      // This will clear the httpOnly cookie on the server
      await apiService.post('/auth/logout');
    } catch (error) {
      // Continue with logout even if server request fails
      console.warn('Logout request failed:', error);
    }
  }

}

export default new AuthService();